import { combineReducers } from 'redux';

import stageReducer, * as fromStage from './reducer.stage';
import bookInputsReducer, * as fromInputs from './reducer.bookInputs';
import completedFieldsReducer, * as fromCompleted from './reducer.completedFields';
import validationReducer, * as fromValidation from './reducer.validation';

export default combineReducers({
  stage: stageReducer,
  bookInputs: bookInputsReducer,
  completedFields: completedFieldsReducer,
  validation: validationReducer,
});

// State accessors

export const getCurrentStage = state => fromStage.getCurrentStage(state.stage);
export const getBookInputs = state =>
  fromInputs.getBookInputData(state.bookInputs);
export const hasUnsavedChanges = state =>
  fromInputs.hasUnsavedChanges(state.bookInputs);
export const getCompletedFields = state =>
  fromCompleted.getCompletedFields(state.completedFields);
export const getFieldInEdit = state =>
  fromCompleted.getFieldInEdit(state.completedFields);

export const isValid = state => fromValidation.isValid(state.validation);
export const getFieldsInError = state =>
  fromValidation.getFieldsInError(state.validation);
